export default __webpack_public_path__ + "static/media/misc-drawerA-1024w.f8aa2251.png";